var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeroBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 734,
    height: 520,
    viewBox: "0 0 734 520",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_37_531",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 734,
    height: 520
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 734,
    height: 520,
    fill: "#F2C0C1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_37_531)"
  }, /*#__PURE__*/React.createElement("path", {
    shapeRendering: "crispEdges",
    d: "M287 780C240.318 780 199.023 770.668 163.114 752.003C127.205 732.62 99.1955 705.7 79.0864 671.242C59.6955 636.784 50 596.941 50 551.715V235.131C50 189.905 59.6955 150.422 79.0864 116.682C99.1955 82.2234 127.205 55.662 163.114 36.9972C199.023 18.3324 240.318 9 287 9C333.682 9 374.977 18.3324 410.886 36.9972C446.795 54.9441 474.445 80.7877 493.836 114.528C513.945 147.55 524 186.316 524 230.824V237.285C524 240.874 522.564 244.105 519.691 246.976C517.536 249.848 514.664 251.284 511.073 251.284L410.886 255.591C402.268 255.591 397.959 251.284 397.959 242.669V229.747C397.959 196.007 387.545 168.728 366.718 147.909C346.609 127.091 320.036 116.682 287 116.682C253.245 116.682 225.955 127.091 205.127 147.909C185.018 168.728 174.964 196.007 174.964 229.747V560.33C174.964 594.07 185.018 621.349 205.127 642.168C225.955 662.268 253.245 672.318 287 672.318C320.036 672.318 346.609 662.268 366.718 642.168C387.545 621.349 397.959 594.07 397.959 560.33V546.331C397.959 538.434 402.268 534.486 410.886 534.486L511.073 538.793C514.664 538.793 517.536 540.229 519.691 543.101C522.564 545.254 524 548.126 524 551.715V556.022C524 600.531 513.945 640.014 493.836 674.472C474.445 708.212 446.795 734.415 410.886 753.08C374.977 771.027 333.682 780 287 780Z",
    fill: "#F2C0C1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroBg);
export default __webpack_public_path__ + "static/media/hero_bg.b31b2c47e2addcd5bd2261420629b4be.svg";
export { ForwardRef as ReactComponent };